<template>
  <div class="task-page-header">
    <span class="tooltip-wrapper" @click="$router.back()">
      <i class="fa fa-times close-icon"></i>
    </span>
  </div>

  <div class="row g-2">
    <!-- LEFT PANEL : VISIT TYPES -->
    <div class="col-md-4">
      <div class="ibox mt-2">
        <div class="ibox-title bg-light py-2 d-flex justify-content-between align-items-center">
          <h5 class="mb-0">Visit Types</h5>

          <div class="position-relative cursor-pointer">
            <img src="../../assets/img/create.png" width="17" height="17" alt="Add Visit Type" @click="addVisit()" />
            <div class="tool-tip">
              {{ $t("navigations.add visit type") }}
            </div>
          </div>
        </div>



        <div class="ibox-content p-2">
          <ul class="list-group">
            <li v-for="(visit, index) in visits" :key="visit.id"
              class="list-group-item list-group-item-action d-flex justify-content-between align-items-center"
              :class="{ active: selectedVisit?.id === visit.id }" @click="selectVisit(visit)">
              <span>{{ visit.type }}</span>


              <!-- 3 dots menu -->
              <div class="expand-delete-block cursor-pointer position-relative px-2" tabindex="0"
                @click.stop="toggleVisitMenu(index)" v-on:clickout="closeVisitMenu(index)">
                <i class="fa fa-ellipsis-v"></i>

                <div class="side-popup position-absolute py-2" v-if="showVisitMenu[index]">
                  <div class="d-flex px-3 py-1" @click.stop="editVisit(visit)">

                    <span>Edit</span>
                  </div>
                  <div class="d-flex px-3 py-1" @click.stop="deleteVisit(visit)">
                    <span>Delete</span>
                  </div>
                </div>
              </div>
            </li>


          </ul>
        </div>
      </div>
    </div>

    <!-- RIGHT PANEL : TASK GRID -->
    <div class="col-md-8">
      <div class="ibox mt-2">
        <div class="ibox-title bg-light py-2 d-flex justify-content-between align-items-center">
          <h5 class="mb-0">
            {{ selectedVisit ? selectedVisit.type + " - Check Lists" : "Select a Visit" }}
          </h5>
          <div v-if="selectedVisit" class="position-relative cursor-pointer">
            <img src="../../assets/img/create.png" width="17" height="17" alt="Add Checklist"
              @click="addTask(selectedVisit)" />
            <div class="tool-tip">
              {{ $t("navigations.add check list") }}
            </div>
          </div>

        </div>

        <div class="ibox-content p-3" v-if="selectedVisit">
          <table class="table table-bordered align-middle">
            <thead class="table-light">
              <tr>
                <th style="width: 8%">#</th>
                <th>Check List Name</th>
                <th style="width: 20%" class="text-center">Questionnaire</th>
                <th style="width: 20%" class="text-center">Edit</th>
                <th style="width: 20%" class="text-center">Delete</th>
              </tr>
            </thead>

            <tbody>
              <tr v-if="!tasks.length">
                <td colspan="4" class="text-center text-muted">
                  No tasks available
                </td>
              </tr>

              <tr v-for="(task, index) in tasks" :key="task.id">
                <td>{{ index + 1 }}</td>
                <td>{{ task.name }}</td>
                <td class="text-center">{{ task.questionCount }}</td>
                <td class="text-center">
                  <i class="fa fa-edit edit-delete" style="color:#a13b7c" @click="editTask(task)">
                  </i>
                </td>
                <td class="text-center">
                  <i class="fa fa-trash edit-delete" style="color:#a13b7c" @click="deleteTask(task)">
                  </i>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <div class="ibox-content text-center text-muted" v-else>
          Please select a visit type from the left panel
        </div>
      </div>
    </div>
  </div>
  <!-- cra checklist add/edit modal start -->
  <TaskAddEditModal v-if="showTaskModal" :taskData="editTaskData" :visitType="selectedVisit"
    @closeModal="closeTaskModal" @saved="onChecklistSaved" />
  <!-- cra checklist add/edit modal end -->

  <!-- cra visit type add/edit modal start -->
  <CraVisitTypeAddEditModal v-if="showVisitModal" :editingId="editVisitId" @closeModal="closeVisitModal"
    @saved="onVisitTypeSaved" />
  <!-- cra visit type add/edit modal end -->

</template>

<script src="./CraChecklistConfig.js"></script>
<style scoped>
.list-group-item {
  position: relative !important;
  cursor: pointer;
}

.list-group-item.active {
  position: relative !important;
  z-index: 1;
  background-color: #f1f3f5 !important;
  /* light grey */
  border-color: #e0e0e0 !important;
  color: #202325 !important;
  /* normal text color */
}

.ibox-content {
  overflow: auto !important;
}

.task-page-header {
  position: relative;
  width: 100%;
  height: 30px;
}

.tooltip-wrapper {
  position: absolute;
  right: 10px;
  top: 5px;
  cursor: pointer;
  z-index: 9999;
}

.close-icon {
  font-size: 18px;
  color: #555;
}

.close-icon:hover {
  color: #000;
}

/* Tooltip */
.custom-tooltip {
  position: absolute;
  top: 22px;
  right: 0;
  background: #000;
  color: #fff;
  font-size: 12px;
  padding: 4px 8px;
  border-radius: 4px;
  white-space: nowrap;
  opacity: 0;
  visibility: hidden;
  transition: all 0.2s ease;
}

.tooltip-wrapper:hover .custom-tooltip {
  opacity: 1;
  visibility: visible;
}

.position-relative {
  position: relative;
}

.tool-tip {
  position: absolute;
  bottom: 125%;
  left: 50%;
  transform: translateX(-50%);
  background: #000;
  color: #fff;
  padding: 4px 8px;
  border-radius: 4px;
  font-size: 11px;
  white-space: nowrap;
  opacity: 0;
  pointer-events: none;
  transition: opacity 0.2s ease;
  z-index: 1000;
}

.position-relative:hover .tool-tip,
.position-relative:focus-within .tool-tip {
  opacity: 1;
}

.expand-delete-block:is(:hover, :focus) {
  border-radius: 50%;
  background-color: #dddddd;
}

.side-popup {
  text-align: left;
  left: -160px;
  width: 160px;
  border-radius: 5px;
  border: 1px solid #e7eaec;
  background-color: #fff;
  box-shadow: 3px 3px 3px rgba(160, 160, 160, 0.5);
  z-index: 200;
}

.side-popup>div:hover {
  background-color: #e4eaf9;
}
</style>
